import { atom } from "jotai";

import { Account } from "../types";
import { sessionAtom } from "./sessionAtom";

// Derived atom that reads currentAccountId from the session
export const currentAccountIdAtom = atom((get) => {
  const session = get(sessionAtom);
  return session?.current_account_id;
});
currentAccountIdAtom.debugLabel = "currentAccountIdAtom";

export const accountAtom = atom<Account | null>(null);
accountAtom.debugLabel = `accountAtom`;
